import { AccredibleResponsiveMenuItem } from '@accredible-frontend-v2/components/responsive-menu';
import { AccredibleUser } from '@accredible-frontend-v2/models';
import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'accredible-base-header-menu',
  templateUrl: './base-header-menu.component.html',
  styleUrls: [`./base-header-menu.component.scss`],
  // ChangeDetectionStrategy.OnPush can't be activated (in both this and rp/acs-header-menu components) due to an issue in the MaterialMenu Component.
  // If activated the attribute aria-expanded="true" is not removed
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseHeaderMenuComponent implements OnInit {
  @Input()
  dynamicMenuItems: AccredibleResponsiveMenuItem[] = [];
  @Input()
  staticMenuItems: AccredibleResponsiveMenuItem[] = [];
  @Input()
  user: AccredibleUser;
  @Input()
  redrawObservable: Observable<unknown>;

  @Output()
  menuActivated = new EventEmitter<boolean>();

  themeHeaderHeight: number;
  readonly menuTriggerButtonId = 'baseMenuTriggerButton';

  constructor(@Inject(DOCUMENT) private readonly _document: Document) {}

  ngOnInit(): void {
    this.themeHeaderHeight = parseInt(
      getComputedStyle(this._document.body).getPropertyValue('--theme-header-height'),
    );
  }

  onMenuActivated(): void {
    this.menuActivated.emit(true);
  }
}
